import React,{Component} from 'react'
import fire from '../../../../database/firebase'
import styled from 'styled-components'
import MediaQuery from 'react-responsive';
import SignUpCustomerSm from '../../../SmallPhone/SignUpPage/Customer-Side/SignUpCustomerSm';

const Styles2 = styled.div `

    // - - CUSTOMER HOME - - //

.customerHome {
    margin-left: 5%;
}

`

export default class SignUpCustomer extends Component {
    constructor (props) {
        super(props)
        this.state = {

        }
    }

    login = () => {
        fire.auth().signInWithEmailAndPassword("norman@autom8d.com", '123456')
        .then((user) => {
            window.location.href = '/home'
        })
        .catch((error) => {

        })
    }

    renderComputerPage = () => {
        return(
            <div className='customerHome'>
                <h1>Customer Home</h1>
                <button
                onClick={this.login}
                >Login</button>
            </div>
        )
    }

    renderSmallPhonePage = () => {
        return (
            <SignUpCustomerSm/>
        )
    }
    

    render () {

        const computerMediaQuery = `(min-width: 1025px)`
        const tabletMediaQuery = `(min-width: 769px) and (max-width: 1024px)`; 
        const phabletMediaQuery = `(min-width: 415px) and (max-width: 768px)`
        // const standardPhoneQuery = `(min-width: 376px) and (max-width: 414px)`
        const smallPhoneQuery = `(min-width: 320px) and (max-width: 414px)`

        return (
            <Styles2>
                {/*  - - RENDER LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerMediaQuery}>
                    {this.renderComputerPage()}
                </MediaQuery>

                {/*  - - RENDER SMALL PHONE VIEW - - */}

                <MediaQuery query={smallPhoneQuery}>
                    {this.renderSmallPhonePage()}
                </MediaQuery>

                
            </Styles2>
        )
    }
}